import view1 from "./imgs/view1.jpg";
import view03 from "./imgs/view03.jpg";
import view04 from "./imgs/view04.jpg";
import view05 from "./imgs/view05.jpg";
import view06 from "./imgs/view06.jpg";
import view07 from "./imgs/view07.jpg";
import view08 from "./imgs/view08.jpg";
import view10 from "./imgs/view10.jpg";
import view11 from "./imgs/view11.jpg";
import view12 from "./imgs/view12.jpg";
import view13 from "./imgs/view13.jpg";
import view14 from "./imgs/view14.jpg";
import Urls from "../../constants/urls";

export const homeUrl = Urls.stlBlues.root.path;

const productIds = {
  adidasAeroreadyAuthenticHomeJersey: '4834047557717',
  adidasAeroreadyAuthenticAwayJersey: '4737783627861',
  adidasAeroreadyAuthenticRetro90sJersey: '4125228269653',
  stlBlues2022WClassicAuthentic: "6623845941333",
}

const playoffProductIds = {
  faulkYeahShortSleeveTee: "6768534847573",
  vladiShortSleeveTee: "6768535011413",
  bleedBlueNavyTee: "6752441401429",
  bluesOReillyFactor: "6760598208597",
  davidPerronDp57Tee: "6760598339669",
  thomasEliteTee: "6760598470741",
  stanleyCupHockeyPuck: "6761315663957",
  fanaticsPlayoffsHat: "6764378423381",
  fanaticsBluesTee: "6764378194005"
}

export const shopifyData = {
    domain: "stl-authentics.myshopify.com",
    token: "a9a80abf3b12d2f5113a2c79c297c560",
    productIds: Object.values(productIds),
    playoffProductIds: Object.values(playoffProductIds),
};


export const view1Hotspots = [
  //carts
  {
    type:"cart",
    xPosition: -22,
    yPosition: 0.25,
    zPosition: -27.5,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.25,
    zPosition: -60,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor
  },
  {
    type:"cart",
    xPosition: 24.5,
    yPosition: 1.5,
    zPosition: -60,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: -0.25,
    zPosition: -44,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.25,
    zPosition: -31,
    yRotation: -10,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.25,
    zPosition: -21.5,
    yRotation: -10,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee
  },
  {
    type:"cart",
    xPosition: 15,
    yPosition: 0.25,
    zPosition: -60,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -17.5,
    yPosition: 0.25,
    zPosition: -46,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -14.5,
    yPosition: 0.25,
    zPosition: -55,
    yRotation: 50,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -0.5,
    yPosition: 0.25,
    zPosition: -60,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 3,
    yPosition: 1,
    zPosition: -60,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: -8.25,
    yPosition: 0.25,
    zPosition: -60,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 7.5,
    yPosition: 0.25,
    zPosition: -60,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  //spots
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: -150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: -150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view6.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: -150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view7.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: -90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view10.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: -90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "external-arrow",
    xPosition: 120,
    yPosition: -20,
    zPosition: 8,
    xRotation: -90,
    yRotation: 0,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view3Hotspots = [
  //carts
  {
    type:"cart",
    xPosition: -20.5,
    yPosition: 0.5,
    zPosition: 12.5,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: -7.75,
    yPosition: 0.5,
    zPosition: -24.5,
    yRotation: 30,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 19,
    yPosition: 0.5,
    zPosition: -15,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 1,
    zPosition: -11.25,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0.5,
    zPosition: -7.5,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 0.5,
    zPosition: -23,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -17.5,
    yPosition: 0.5,
    zPosition: -13,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -14.5,
    yPosition: 0.5,
    zPosition: -20.5,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -0.5,
    yPosition: 0.5,
    zPosition: -26,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 2.75,
    yPosition: 1,
    zPosition: -26,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 7.5,
    yPosition: 0.5,
    zPosition: -26,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.5,
    zPosition: 10.5,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.5,
    zPosition: 20,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  //spots
  {
    type: "spot",
    xPosition: -15,
    yPosition: -17,
    zPosition: -75,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 7,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: 15,
    yPosition: -25,
    zPosition: -170,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 15,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "spot",
    xPosition: 50,
    yPosition: -25,
    zPosition: -150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 15,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: -70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: -25,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: -90,
    yPosition: -25,
    zPosition: -90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "external-arrow",
    xPosition: 120,
    yPosition: -20,
    zPosition: 0,
    xRotation: -90,
    yRotation: 0,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view1.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view7.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view10.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: Urls.stlBlues.view6.path
  },
]

export const view4Hotspots = [
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 29,
    yRotation: 100,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 0.5,
    zPosition: 4,
    yRotation: -70,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 1.5,
    zPosition: 7,
    yRotation: -70,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 0.5,
    zPosition: 10.5,
    yRotation: -80,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 0.5,
    zPosition: 25,
    yRotation: -110,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 0.5,
    zPosition: 32.25,
    yRotation: -110,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 14.75,
    yPosition: 0.5,
    zPosition: -3,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 4.75,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -15.5,
    yPosition: 0.5,
    zPosition: -2.75,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -11,
    yPosition: 0.25,
    zPosition: -10.25,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -0.5,
    yPosition: 0.5,
    zPosition: -11.5,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 3.5,
    yPosition: 1,
    zPosition: -11.5,
    yRotation: 40,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 8.5,
    yPosition: 0.5,
    zPosition: -9,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 100,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: 90,
    yPosition: -25,
    zPosition: 70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 40,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "spot",
    xPosition: 50,
    yPosition: -25,
    zPosition: -20,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 7,
    linkRotation: 120,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "spot",
    xPosition: 15,
    yPosition: -25,
    zPosition: -45,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 7,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "external-arrow",
    xPosition: 120,
    yPosition: -20,
    zPosition: 120,
    xRotation: -90,
    yRotation: 0,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view5Hotspots = [
  {
    type:"cart",
    xPosition: -20.75,
    yPosition: 0.25,
    zPosition: -7,
    yRotation: 10,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 13,
    yPosition: 0.5,
    zPosition: -5.5,
    yRotation: -10,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 0.25,
    zPosition: -1,
    yRotation: -40,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 0.5,
    zPosition: 23.5,
    yRotation: -120,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 8.5,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -120,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 5.5,
    yPosition: 1.5,
    zPosition: 24.5,
    yRotation: -130,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 2.75,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -130,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: -9,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -15,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 25,
    yPosition: 0.25,
    zPosition: 5.75,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 26.5,
    yPosition: 0.25,
    zPosition: 14.5,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 22,
    yPosition: 1,
    zPosition: 14.5,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 22.5,
    yPosition: 0.5,
    zPosition: 21,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type: "spot",
    xPosition: -40,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "spot",
    xPosition: 140,
    yPosition: -25,
    zPosition: 110,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "spot",
    xPosition: 130,
    yPosition: -25,
    zPosition: 145,
    xRotation: -88,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "spot",
    xPosition: 50,
    yPosition: -25,
    zPosition: 180,
    xRotation: -88,
    yRotation: 180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view6.path
  },
  {
    type: "spot",
    xPosition: -150,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "external-arrow",
    xPosition: -15,
    yPosition: -20,
    zPosition: 170,
    xRotation: -90,
    yRotation: -90,
    zRotation: 10,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view6Hotspots = [
  {
    type:"cart",
    xPosition: 0.25,
    yPosition: 0.25,
    zPosition: -7,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 28.5,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 28,
    yPosition: 0.5,
    zPosition: -5,
    yRotation: -40,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: 21.25,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 1.5,
    zPosition: 22.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 12.25,
    yPosition: 0.75,
    zPosition: 21.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 2.25,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -4.25,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 30,
    yPosition: 0.5,
    zPosition: -0.75,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: 34,
    yPosition: 0.5,
    zPosition: 5,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 37.5,
    yPosition: 0.5,
    zPosition: 13,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 30.5,
    yPosition: 1,
    zPosition: 13,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 37.5,
    yPosition: 0.5,
    zPosition: 21.5,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type: "spot",
    xPosition: -60,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "spot",
    xPosition: 120,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: 40,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view7.path
  },
  {
    type: "spot",
    xPosition: -45,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view10.path
  },
  {
    type: "spot",
    xPosition: 160,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "spot",
    xPosition: -120,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view1.path
  },
  {
    type: "external-arrow",
    xPosition: -125,
    yPosition: -20,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
  {
    type: "external-arrow",
    xPosition: 65,
    yPosition: -20,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view7Hotspots = [
  {
    type:"cart",
    xPosition: -6.5,
    yPosition: 0.25,
    zPosition: -7,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 14.5,
    yPosition: 0.25,
    zPosition: -7,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 0,
    yPosition: 0.5,
    zPosition: 30.5,
    yRotation: 180,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 0.75,
    zPosition: 27.5,
    yRotation: 120,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -28,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -36,
    yPosition: 0.5,
    zPosition: 23,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 0.5,
    zPosition: 15.25,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 1,
    zPosition: 12,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 0.5,
    zPosition: 8,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: -37,
    yPosition: 0.5,
    zPosition: 1.5,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -37,
    yPosition: 0.5,
    zPosition: -3,
    yRotation: 110,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: -29,
    yPosition: -1.5,
    zPosition: -2,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: -26,
    yPosition: 0.75,
    zPosition: -4,
    yRotation: 130,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type: "spot",
    xPosition: 60,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view10.path
  },
  {
    type: "spot",
    xPosition: 120,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view1.path
  },
  {
    type: "spot",
    xPosition: 50,
    yPosition: -25,
    zPosition: 170,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 170,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view6.path
  },
  {
    type: "spot",
    xPosition: -50,
    yPosition: -25,
    zPosition: 90,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -150,
    yPosition: -25,
    zPosition: 20,
    xRotation: -88,
    yRotation: -200,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  }, 
  {
    type: "external-arrow",
    xPosition: -75,
    yPosition: -20,
    zPosition: 10,
    xRotation: -90,
    yRotation: 90,
    zRotation: 10,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view8Hotspots = [
  {
    type:"cart",
    xPosition: 18.5,
    yPosition: 0.5,
    zPosition: 30,
    yRotation: 180,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: -11,
    yPosition: -0.25,
    zPosition: -6,
    yRotation: 30,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: -1,
    yPosition: 0.5,
    zPosition: -6,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 6,
    yPosition: 0.5,
    zPosition: -6,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0.25,
    zPosition: -3,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 30,
    yPosition: 0.25,
    zPosition: -3,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -19,
    yPosition: 0,
    zPosition: 2.5,
    yRotation: 50,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -22,
    yPosition: 0,
    zPosition: 10.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 0.25,
    zPosition: 17.5,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 1,
    zPosition: 13.5,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: -18,
    yPosition: 0.25,
    zPosition: 26.5,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -10.75,
    yPosition: 0.5,
    zPosition: 30,
    yRotation: 140,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -3.25,
    yPosition: 0.5,
    zPosition: 30,
    yRotation: 180,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type: "spot",
    xPosition: 90,
    yPosition: -25,
    zPosition: 120,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -20,
    yPosition: -25,
    zPosition: 120,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: 130,
    yPosition: -25,
    zPosition: 10,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view7.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 100,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 60,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "external-arrow",
    xPosition: 75,
    yPosition: -20,
    zPosition: -10,
    xRotation: -90,
    yRotation: 90,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view10Hotspots = [
  {
    type:"cart",
    xPosition: -23.5,
    yPosition: 0.25,
    zPosition: -6,
    yRotation: 30,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -5.5,
    yPosition: 0.25,
    zPosition: -6,
    yRotation: 30,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -6.75,
    yPosition: 0.5,
    zPosition: 29.5,
    yRotation: 180,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: -26.5,
    yPosition: 0.75,
    zPosition: 27.5,
    yRotation: 120,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -34.5,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -37.5,
    yPosition: 0.5,
    zPosition: 20,
    yRotation: 120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 0.5,
    zPosition: 13,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 1,
    zPosition: 10,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: -38,
    yPosition: 0.5,
    zPosition: 6.75,
    yRotation: 90,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: -37,
    yPosition: 0.5,
    zPosition: 1.5,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: -40,
    yPosition: 0.5,
    zPosition: -2.5,
    yRotation: 90,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: -34,
    yPosition: -1.5,
    zPosition: -2,
    yRotation: 60,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: -36,
    yPosition: 0.75,
    zPosition: -4,
    yRotation: 130,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view1.path
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 170,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view11.path
  },
  {
    type: "spot",
    xPosition: -50,
    yPosition: -25,
    zPosition: 170,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view6.path
  },
  {
    type: "spot",
    xPosition: -90,
    yPosition: -25,
    zPosition: 120,
    xRotation: -88,
    yRotation: -180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 20,
    xRotation: -88,
    yRotation: -200,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view7.path
  }, 
  {
    type: "external-arrow",
    xPosition: -125,
    yPosition: -20,
    zPosition: 10,
    xRotation: -90,
    yRotation: 90,
    zRotation: 10,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
  {
    type: "external-arrow",
    xPosition: 105,
    yPosition: -20,
    zPosition: 10,
    xRotation: -90,
    yRotation: 90,
    zRotation: -10,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view11Hotspots = [
  {
    type:"cart",
    xPosition: 13,
    yPosition: 0.5,
    zPosition: -8,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 28,
    yPosition: 0.5,
    zPosition: -4,
    yRotation: -40,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: 31,
    yPosition: 0.5,
    zPosition: -0.75,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: 34,
    yPosition: 0.5,
    zPosition: 4,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 37.5,
    yPosition: 0.5,
    zPosition: 11,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 37.5,
    yPosition: 1,
    zPosition: 13.5,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 37.5,
    yPosition: 0.5,
    zPosition: 18,
    yRotation: -100,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: 29.5,
    yPosition: 0.5,
    zPosition: 20.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 25.25,
    yPosition: 0.5,
    zPosition: 24.5,
    yRotation: -100,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 24.25,
    yPosition: 1.5,
    zPosition: 26.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 21.5,
    yPosition: 0.75,
    zPosition: 26.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 8.25,
    yPosition: 0.5,
    zPosition: 25.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 2,
    yPosition: 0.5,
    zPosition: 25.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type: "spot",
    xPosition: 140,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view6.path
  },
  {
    type: "spot",
    xPosition: 100,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: 45,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view7.path
  },
  {
    type: "spot",
    xPosition: 0,
    yPosition: -25,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view10.path
  },
  {
    type: "spot",
    xPosition: -80,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view1.path
  },
  {
    type: "external-arrow",
    xPosition: -105,
    yPosition: -20,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
  {
    type: "external-arrow",
    xPosition: 105,
    yPosition: -20,
    zPosition: 150,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view12Hotspots = [
  {
    type:"cart",
    xPosition: -32,
    yPosition: 0.25,
    zPosition: -7,
    yRotation: 15,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 2,
    yPosition: 0.5,
    zPosition: -7,
    yRotation: -10,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: 12,
    yPosition: 0.25,
    zPosition: -1.5,
    yRotation: -40,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: 18,
    yPosition: 0.25,
    zPosition: 6.75,
    yRotation: -60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0.25,
    zPosition: 17.25,
    yRotation: -90,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 20,
    yPosition: 0.5,
    zPosition: 21,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 15.25,
    yPosition: 0.5,
    zPosition: 23.5,
    yRotation: -120,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: 8.5,
    yPosition: 0.5,
    zPosition: 26.5,
    yRotation: -120,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 1.5,
    yPosition: 0.5,
    zPosition: 28.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: -1.75,
    yPosition: 1.5,
    zPosition: 28.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: -4.75,
    yPosition: 0.5,
    zPosition: 28.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 28.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -25.5,
    yPosition: 0.5,
    zPosition: 28.5,
    yRotation: -180,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type: "spot",
    xPosition: -20,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: 80,
    yPosition: -25,
    zPosition: 130,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "spot",
    xPosition: 60,
    yPosition: -25,
    zPosition: 155,
    xRotation: -88,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "spot",
    xPosition: -20,
    yPosition: -25,
    zPosition: 180,
    xRotation: -88,
    yRotation: 180,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -70,
    yPosition: -25,
    zPosition: 0,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "external-arrow",
    xPosition: -65,
    yPosition: -20,
    zPosition: 180,
    xRotation: -90,
    yRotation: -90,
    zRotation: 10,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view13Hotspots = [
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 31.5,
    yRotation: 100,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 0.5,
    zPosition: 10.5,
    yRotation: 80,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 3.5,
    yRotation: 60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -17.5,
    yPosition: 0.25,
    zPosition: -3.5,
    yRotation: 60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -5.5,
    yPosition: 0,
    zPosition: -8.5,
    yRotation: 0,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: 2,
    yPosition: 0,
    zPosition: -8.5,
    yRotation: 0,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: 10.25,
    yPosition: 0,
    zPosition: -4,
    yRotation: -30,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: 18.5,
    yPosition: 0,
    zPosition: 4.5,
    yRotation: -50,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 22.75,
    yPosition: 0,
    zPosition: 14.75,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 18.75,
    yPosition: 1,
    zPosition: 16,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 16.75,
    yPosition: 0.5,
    zPosition: 18,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type:"cart",
    xPosition: 12.75,
    yPosition: 0.5,
    zPosition: 25.75,
    yRotation: -110,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 12.75,
    yPosition: 0.5,
    zPosition: 32.75,
    yRotation: -110,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type: "spot",
    xPosition: -10,
    yPosition: -25,
    zPosition: 190,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -10,
    yPosition: -25,
    zPosition: 100,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 140,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: 90,
    yPosition: -25,
    zPosition: 110,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "spot",
    xPosition: 60,
    yPosition: -25,
    zPosition: 50,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view14.path
  },
  {
    type: "external-arrow",
    xPosition: 100,
    yPosition: -20,
    zPosition: 150,
    xRotation: -93,
    yRotation: 0,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const view14Hotspots = [
  {
    type:"cart",
    xPosition: -10.5,
    yPosition: 0.5,
    zPosition: 40,
    yRotation: 130,
    radius: 0.75,
    productId: playoffProductIds.bleedBlueNavyTee,
  },
  {
    type:"cart",
    xPosition: 20.75,
    yPosition: 0.5,
    zPosition: 22.75,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.faulkYeahShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: 20.75,
    yPosition: 0.5,
    zPosition: 25.75,
    yRotation: -90,
    radius: 0.75,
    productId: playoffProductIds.vladiShortSleeveTee,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 0.5,
    zPosition: 18.5,
    yRotation: 100,
    radius: 0.75,
    productId: playoffProductIds.davidPerronDp57Tee,
  },
  {
    type:"cart",
    xPosition: -20,
    yPosition: 0.5,
    zPosition: 10.5,
    yRotation: 80,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticRetro90sJersey,
  },
  {
    type:"cart",
    xPosition: -18.5,
    yPosition: 0.5,
    zPosition: 3.5,
    yRotation: 60,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticAwayJersey,
  },
  {
    type:"cart",
    xPosition: -17.5,
    yPosition: 0.25,
    zPosition: -3.5,
    yRotation: 60,
    radius: 0.75,
    productId: productIds.stlBlues2022WClassicAuthentic,
  },
  {
    type:"cart",
    xPosition: -13.5,
    yPosition: -0.25,
    zPosition: -6.5,
    yRotation: 30,
    radius: 0.75,
    productId: playoffProductIds.stanleyCupHockeyPuck,
  },
  {
    type:"cart",
    xPosition: -5.5,
    yPosition: 0,
    zPosition: -7.5,
    yRotation: 40,
    radius: 0.75,
    productId: productIds.adidasAeroreadyAuthenticHomeJersey,
  },
  {
    type:"cart",
    xPosition: 10.25,
    yPosition: 0,
    zPosition: -3.5,
    yRotation: -30,
    radius: 0.75,
    productId: playoffProductIds.thomasEliteTee,
  },
  {
    type:"cart",
    xPosition: 18.5,
    yPosition: 0,
    zPosition: 5.5,
    yRotation: -50,
    radius: 0.75,
    productId: playoffProductIds.bluesOReillyFactor,
  },
  {
    type:"cart",
    xPosition: 18.5,
    yPosition: 1,
    zPosition: 8.5,
    yRotation: -60,
    radius: 0.75,
    productId: playoffProductIds.fanaticsPlayoffsHat,
  },
  {
    type:"cart",
    xPosition: 18.5,
    yPosition: 0.5,
    zPosition: 12,
    yRotation: -70,
    radius: 0.75,
    productId: playoffProductIds.fanaticsBluesTee,
  },
  {
    type: "spot",
    xPosition: -10,
    yPosition: -25,
    zPosition: 190,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view3.path
  },
  {
    type: "spot",
    xPosition: -10,
    yPosition: -25,
    zPosition: 100,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view4.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 140,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view5.path
  },
  {
    type: "spot",
    xPosition: 90,
    yPosition: -25,
    zPosition: 90,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view8.path
  },
  {
    type: "spot",
    xPosition: -100,
    yPosition: -25,
    zPosition: 70,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 12,
    linkRotation: 120,
    link: Urls.stlBlues.view12.path
  },
  {
    type: "spot",
    xPosition: -60,
    yPosition: -25,
    zPosition: 50,
    xRotation: -90,
    yRotation: -90,
    zRotation: 0,
    radius: 10,
    linkRotation: 120,
    link: Urls.stlBlues.view13.path
  },
  {
    type: "external-arrow",
    xPosition: 110,
    yPosition: -20,
    zPosition: 105,
    xRotation: -90,
    yRotation: 20,
    zRotation: 0,
    radius: 12,
    link: 'https://www.stlauthentics.com/'
  },
]

export const rooms = [
    {
      id:'view1',
      name: "View 1",
      img: view1,
      route: Urls.stlBlues.view1,
      yRotation: 180,
      linkRotation: 180,
    },
    {
      id:'view3',
      name: "View 3",
      img: view03,
      route: Urls.stlBlues.view3,
      yRotation: 360,
    },
    {
      id:'view4',
      name: "View 4",
      img: view04,
      route: Urls.stlBlues.view4,
      yRotation: -88,
    },
    {
      id:'view5',
      name: "View 5",
      img: view05,
      route: Urls.stlBlues.view5,
      yRotation: 90,
    },
    {
        id:'view6',
        name: "View 6",
        img: view06,
        route: Urls.stlBlues.view6,
        yRotation: 90,
    },
    {
        id:'view7',
        name: "View 7",
        img: view07,
        route: Urls.stlBlues.view7,
        yRotation: 90,
    },
    {
        id:'view8',
        name: "View 8",
        img: view08,
        route: Urls.stlBlues.view8,
        yRotation: 90,
    },
    {
        id:'view10',
        name: "View 10",
        img: view10,
        route: Urls.stlBlues.view10,
        yRotation: 90,
    },
    {
      id:'view11',
      name: "View 11",
      img: view11,
      route: Urls.stlBlues.view11,
      yRotation: 90,
    },
    {
        id:'view12',
        name: "View 12",
        img: view12,
        route: Urls.stlBlues.view12,
        yRotation: 90,
    },
    {
      id:'view13',
      name: "View 13",
      img: view13,
      route: Urls.stlBlues.view13,
      yRotation: 90,
    },
    {
      id:'view14',
      name: "View 14",
      img: view14,
      route: Urls.stlBlues.view14,
      yRotation: 90,
    },
    
  ];
